export default "__VITE_ASSET__Ct_95hGZ__"